import React from "react";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import { criarAuditoriaDs } from "../DataSources.js";

export default class AuditoriaBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filtro: {},
    };
    this.auditoriaDs = criarAuditoriaDs();
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this._gridInstance = React.createRef();

    this.operacaoOptions = {
      editorType: "dxSelectBox",
      dataSource: [
        { id: -1, descricao: "Todos" },
        { id: 0, descricao: "Outros" },
        { id: 1, descricao: "Inalterado" },
        { id: 2, descricao: "Deletado" },
        { id: 3, descricao: "Modificado" },
        { id: 4, descricao: "Adicionado" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    }
  }


  filtrar(e) {
    let filtro = [];
    let estado = this.state.filtro;

    console.log(estado)

    if (
      estado.dataInicial !== null &&
      estado.dataInicial !== undefined &&
      estado.dataInicial !== ""
    ) {
      filtro.push(["data", ">=", estado.dataInicial]);
    }
    if (
      estado.dataFinal !== null &&
      estado.dataFinal !== undefined &&
      estado.dataFinal !== ""
    ) {
      filtro.push(["data", "<=", estado.dataFinal]);
    }

    if (
      estado.operacao != undefined &&
      estado.operacao !== -1
    ) {
      filtro.push(["operacao", "=", estado.operacao]);
    }

    this._gridInstance.instance.filter(filtro.length > 0 ? filtro : null);
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form
              id="frmPesquisa"
              formData={this.state.filtro}
              colCount={3}
              labelLocation={"top"}
            >
              <SimpleItem
                dataField="dataInicial"
                editorType="dxDateBox"
                editorOptions={{
                  displayFormat: "dd/MM/yyyy",
                  width: "100%",
                  useMaskBehavior: true,
                }}
              >
                <Label text="Data Inicial" />
              </SimpleItem>

              <SimpleItem
                dataField="dataFinal"
                editorType="dxDateBox"
                editorOptions={{
                  displayFormat: "dd/MM/yyyy",
                  width: "100%",
                  useMaskBehavior: true,
                }}
              >
                <Label text="Data Final" />
              </SimpleItem>
              <SimpleItem
                dataField="operacao"
                editorType={"dxSelectBox"}
                editorOptions={this.operacaoOptions}
              >
                <Label text="Operação" />
              </SimpleItem>
            </Form>
            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br />
          <br />
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.auditoriaDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
          >
            <Column dataField={"id"} caption={"#"} width={80} />
            <Column dataField={"usuario.nome"} caption={"Autor"} />
            <Column dataField={"data"} dataType={"datetime"} />
            <Column dataField={"tabela"} />
            <Column
              dataField={"operacao"}
              caption={"Operação"}
              alignment={"left"}
              customizeText={(cellInfo) => {
                if (cellInfo.value === 0) return "Outros";
                if (cellInfo.value === 1) return "Inalterado";
                if (cellInfo.value === 2) return "Deletado";
                if (cellInfo.value === 3) return "Modificado";
                if (cellInfo.value === 4) return "Adicionado";
              }}
            />
            <Column
              dataField={"entidadeId"}
              caption={"ID Entidade"}
              alignment={"left"}
              width={90}
            />
            <Column
              dataField={"entidadeSequencial"}
              caption={"Seq. Entidade"}
              alignment={"left"}
              width={90}
            />
            <Column dataField={"colunasAlteradas"} />
            <Column dataField={"dadosAntigos"} />
            <Column dataField={"dadosNovos"} />
          </DataGrid>
        </div>
      </React.Fragment>
    );
  }
}
